export const version = '2.22.1';
//# sourceMappingURL=version.js.map